module.exports = __webpack_public_path__ + "static/media/compliance_documentation1.2f8e680a.png";